// Mock data for GENSOL website

export const equipmentData = {
  generators: [
    {
      id: 1,
      name: "Generadores 5-50 KW",
      description: "Perfectos para eventos, construcciones pequeñas y respaldo residencial",
      power: "5 - 50 KW",
      features: ["Silenciosos", "Eficientes", "Portátiles"],
      image: "https://customer-assets.emergentagent.com/job_44da33e2-9df0-4e2d-82b0-9d3a733fa63e/artifacts/7d1x5kja_Planta%20de%20luz%20de%2020Kw.png"
    },
    {
      id: 2,
      name: "Generadores 50-250 KW",
      description: "Ideales para proyectos medianos, eventos grandes y obras de construcción",
      power: "50 - 250 KW",
      features: ["Alta potencia", "Confiables", "Bajo consumo"],
      image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/omaduh0c_generadores%20electricos%20de%2050kw%20con%20caseta%20acustica%20en%20renta%20veracruz.jpg"
    },
    {
      id: 3,
      name: "Generadores 250-1000 KW",
      description: "Soluciones industriales para grandes proyectos y operaciones continuas",
      power: "250 - 1000 KW",
      features: ["Máxima potencia", "Operación 24/7", "Soporte técnico"],
      image: "https://customer-assets.emergentagent.com/job_44da33e2-9df0-4e2d-82b0-9d3a733fa63e/artifacts/4vnz1amx_renta%20generador%20electrico%20de%20500kw.jpg"
    }
  ],
  lightTowers: [
    {
      id: 4,
      name: "Torres de Iluminación Estándar",
      description: "Iluminación potente para áreas de construcción y eventos nocturnos",
      coverage: "Hasta 5,000 m²",
      features: ["360° iluminación", "Altura ajustable", "Bajo consumo"],
      image: "https://images.pexels.com/photos/34224283/pexels-photo-34224283.jpeg"
    },
    {
      id: 5,
      name: "Torres de Iluminación LED",
      description: "Tecnología LED de última generación para máxima eficiencia",
      coverage: "Hasta 7,500 m²",
      features: ["Tecnología LED", "Ahorro energético", "Mayor vida útil"],
      image: "https://images.pexels.com/photos/34203551/pexels-photo-34203551.jpeg"
    }
  ],
  welders: [
    {
      id: 6,
      name: "Soldadoras Portátiles",
      description: "Equipos de soldadura móviles para trabajos en campo",
      power: "200-400 Amp",
      features: ["Portátil", "Multi-proceso", "Fácil transporte"],
      image: "https://images.unsplash.com/photo-1727098730153-6408da60d89d"
    },
    {
      id: 7,
      name: "Soldadoras Industriales",
      description: "Máquinas de soldadura de alta capacidad para trabajos pesados",
      power: "400-600 Amp",
      features: ["Alta capacidad", "Ciclo trabajo 100%", "Profesional"],
      image: "https://images.pexels.com/photos/34194569/pexels-photo-34194569.jpeg"
    }
  ],
  integralService: {
    id: 8,
    name: "Servicio Integral",
    description: "¿Requieres de personal en sitio? Nuestro equipo se encarga de la logística de entrega, devolución y maniobras, el combustible y técnico en sitio",
    tagline: "¡Déjalo en manos de los expertos!",
    features: ["Logística completa", "Técnico en sitio", "Combustible incluido", "Maniobras especializadas"],
    image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/r50w0spm_servicio%20integral%20de%20tecnico%20y%20generador%20electrico%20para%20evento.jpg"
  },
  repairService: {
    id: 9,
    name: "Reparación y Mantenimiento",
    description: "Servicio especializado de reparación y mantenimiento de equipos electrógenos con personal altamente capacitado",
    tagline: "¿Tu equipo necesita servicio? ¡Ofrecemos renta con precios especiales mientras lo reparamos!",
    features: ["Personal especializado", "Diagnóstico profesional", "Renta especial incluida", "Garantía de servicio"],
    highlight: "Precios especiales en renta para clientes de taller mecánico"
  }
};

export const benefits = [
  {
    id: 1,
    title: "Equipos de Calidad",
    description: "Mantenimiento preventivo constante para garantizar el mejor rendimiento"
  },
  {
    id: 2,
    title: "Disponibilidad 24/7",
    description: "Servicio y soporte técnico disponible en todo momento"
  },
  {
    id: 3,
    title: "Entrega Rápida",
    description: "Servicio de entrega e instalación en toda la zona sureste de México"
  },
  {
    id: 4,
    title: "Asesoría Experta",
    description: "Nuestros especialistas te ayudan a elegir el equipo perfecto"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Martínez",
    company: "Construcciones del Golfo",
    text: "GENSOL nos ha proporcionado generadores confiables para nuestros proyectos. Excelente servicio.",
    rating: 5
  },
  {
    id: 2,
    name: "Ana López",
    company: "Eventos Espectaculares",
    text: "Las torres de iluminación fueron perfectas para nuestro evento nocturno. Muy profesionales.",
    rating: 5
  },
  {
    id: 3,
    name: "Roberto Sánchez",
    company: "Talleres Industriales RS",
    text: "Las soldadoras que rentamos son de excelente calidad. Altamente recomendados.",
    rating: 5
  }
];

export const galleryItems = [
  {
    id: 1,
    title: "Generador 40 KW Portátil",
    category: "Generadores",
    image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/jpsd59ok_generador%20electrico%20de%2040kw%20con%20caseta%20acustica%20en%20renta%20veracruz.jpg",
    description: "Generador con caseta acústica para eventos"
  },
  {
    id: 2,
    title: "Generador 50 KW Industrial",
    category: "Generadores",
    image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/05czd1wy_generador%20electrico%20de%2050kw%20con%20caseta%20acustica%20en%20veracruz.jpg",
    description: "Equipo de alta capacidad para proyectos"
  },
  {
    id: 3,
    title: "Generador en Barco",
    category: "Historias",
    image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/1wn90gsn_generador%20en%20barco.jpg",
    description: "Soluciones energéticas marítimas - Proyecto único"
  },
  {
    id: 4,
    title: "Proyecto San Juan de Ulúa",
    category: "Historias",
    image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/4o1i8jt9_generador%20san%20juan%20de%20ulua.jpg",
    description: "Historia: Generador en sitio histórico de Veracruz"
  },
  {
    id: 5,
    title: "Servicio Integral GENSOL",
    category: "Servicios",
    image: "https://customer-assets.emergentagent.com/job_power-equipment/artifacts/6jgh69k7_servicio%20integral%20de%20tecnico%20y%20generador%20electrico%20para%20evento.jpg",
    description: "Entrega e instalación profesional completa"
  }
];

export const submitContactForm = (formData) => {
  // Mock function - will be replaced with actual API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Mensaje enviado exitosamente" });
    }, 1000);
  });
};